import React from 'react';
import './HongInput.scss';

const HongInput = ({ value, onChange, className, placeholder, 
    isNumber=false, spellCheck=false, autoComplete='off' }) => {//autoComplete='false'로하면 안됨

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (isNumber) { 
        if (/^\d*$/.test(inputValue)) {// 숫자만 허용
          onChange(e); // 유효한 경우 onChange 호출
        }
      } else {
        onChange(e); // 제한 없이 호출
      }
    };
  //---------------------------------------------
  return (
    <input
      type="text"
      className={`hong-input ${className}`}
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      spellCheck={spellCheck} // 스펠체크 비활성화
      autoComplete={autoComplete} // 자동완성 비활성화
    />
  );
};

export default HongInput;
